import domReady from '@roots/sage/client/dom-ready';
import {mainnav} from './mainnav.js';
import {contentElementHelpers} from './contentElementHelpers.js';
import {contentElementAnimations} from './contentElementAnimations.js';
import {debugHelpers} from './debugHelpers.js';
import {popupWindow} from './popupWindow.js';

/**
 * Application entrypoint
 */
domReady(async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  mainnav();
  contentElementHelpers();
  contentElementAnimations();
  popupWindow();
  debugHelpers();
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
